// Entry: loads only the floating accessibility icon. The widget panel is lazy-loaded.
import initAccessibilityIcon from '../icon/Icon';
import { sendBatchedAnalytics, setupAnalyticsCleanup } from '../utils/helpers';

window.accessProPlanName = "FREE";
window.accessProTemplate = "default";
window.accessProFeatures = []
window.accessProTranslations = {}

window.accessProTextToSpeech = null;
window.accessProTextSummary = null;
window.accessProVirtualKeyboaard = null;
window.accessProDictionary = null;

window.accessPro = {}

window.analyticsUsageData = {};
window.isSendingAnalytics = false;
window.analyticsTimeout = null;


// Initialize analytics cleanup when the script loads
setupAnalyticsCleanup();

// Expose sendBatchedAnalytics globally for manual triggering if needed
window.sendBatchedAnalytics = sendBatchedAnalytics;


initAccessibilityIcon();

